import axios from "axios";
import { getAccessToken } from "./okta-config";
import { API_ROOT } from "../constants/constant";

export const getDataWAuth = (url, params = {}) => {
  return callApi(url, params, "get");
};

export const deleteDataWAuth = (url, params = {}) => {
  return callApi(url, params, "delete");
};

export const postDataWAuth = (url, data, params = {}) => {
  return callApi(url, params, "post", data);
};

export const postDataWAuthFile = (url, data, params = {}) => {
  return callApiForFile(url, params, "post", data);
};

export const putDataWAuth = (url, data, params = {}) => {
  return callApi(url, params, "put", data);
};

export const getData = (url) =>
  fetch(url)
    .then((resp) => resp.json())
    .catch((e) => console.log(e));

const callApi = (url, params, method, data) => {
  const accessToken = getAccessToken();

  const headers = {
    "Access-Control-Allow-Origin": API_ROOT,
    Authorization: `Bearer ${accessToken}`,
  };

  return axios({ method, url, data, headers, params })
    .then((response) => {
      if (response.status === 200 || response.status === 202 || response.status === 204) {
        // For 204 No Content, return response with empty data
        if (response.status === 204) {
          return { ...response, data: response.data || [] };
        }
        return response;
      } else {
        console.log("Error Loading data !");
        return null;
      }
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const callApiForFile = (url, params, method, data) => {
  const accessToken = getAccessToken();

  const headers = {
    "Access-Control-Allow-Origin": API_ROOT,
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();
  formData.append("file", data);

  return axios({ method, url, data: formData, headers, params })
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else {
        console.log("Error Loading data !");
        return null;
      }
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};
